import type { RouteRecordRaw } from "vue-router";
import { wheneverOnceAsync } from "ls/composables/wheneverOnceAsync";
import { routeNames } from "ls/router/constants";
import { useAxureCloudConfig } from "ls/state/useAxureCloudConfig";
import { useRouter } from "vue-router";

const buyRoute: RouteRecordRaw = {
  path: "/buy",
  name: routeNames.buyCloudPlus,
  component: () => import("ls/features/buy/BuyCloudPlus.vue"),
};

export function useConfigureBuyCloudRoutes() {
  const router = useRouter();
  const config = useAxureCloudConfig();

  const stop = router.beforeEach(async to => {
    if (!to.path.startsWith(buyRoute.path)) {
      return true;
    }

    if (router.hasRoute(routeNames.buyCloudPlus)) {
      stop();
      return true;
    }

    const configValue = await wheneverOnceAsync(() => config.value);
    // Shouldn't be available on On-Prem or ACB
    if (configValue.AxShareOnPrem || configValue.IsSubInstance) {
      stop();
      return routeNames.notFound;
    }

    router.addRoute(buyRoute);
    stop();
    return to.fullPath;
  });
}
